import { createContext, useContext } from 'react';

/**
 * Provides a default portal target for Dropdown components. When set, any
 * Dropdown whose `appendTo` resolves to `document.body` will instead append
 * to this element. This allows portaled menus to inherit styling (e.g. custom
 * fonts) from their logical parent without changing individual Dropdown props.
 */
const DropdownPortalContext = createContext<Element | null>(null);
DropdownPortalContext.displayName = 'DropdownPortalContext';

export function useDropdownPortalContext() {
  return useContext(DropdownPortalContext);
}

export default DropdownPortalContext;
